<template >
 <div class='bto-sb-element'>
   <iframe :id="iFrameId" :src="iFrameUrl" :style="style" :class="iFrameClass">
   </iframe>
 </div>
</template>

<script>
  import LiveMatchModel from '../live-now/models/live-match-model';
  import PreMatchModel from '../../../models/model-match';
  import { toggleItem, isOddActive, resetQuickbet } from '@bto-services/betslip-core';
  import { mapMatchToBetslipItem, mapMatchToBetslipMatchItem } from 'bto-models/betslip';
  import { showBetslipValidation } from '@bto-services/modal';

  export default {
    name: 'NetbotsRobotipWidget',
    props: {
      iFrameId: {
        type: String,
        label: 'iFrame Id',
      },
      iFrameSrc: {
        type: String,
        label: 'iFrame Src',
        default: '',
      },
      iFrameWidth: {
        type: String,
        label: 'iFrame Width',
      },
      iFrameHeight: {
        type: String,
        label: 'iFrame Height',
      },
      iFrameClass: {
        type: String,
        label: 'Iframe Class',
      },
      iFrameStyle: {
        type: String,
        label: "Iframe custom style",
        default: "border: none;"
      },
    },
    computed: {
      style() {
        const sty = `width: ${this.iFrameWidth}; height: ${this.iFrameHeight}; ${this.iFrameStyle}`;

        return sty;
      },
      iFrameUrl() {
        return this.iFrameSrc.replace('{{langCode}}', APP_SETTINGS.player.language);
      }
    },
    created() {
      window.addEventListener('message', this.netbotsListener);
    },
    destroyed() {
      window.removeEventListener('message', this.netbotsListener);
    },
    methods: {
      /**
       * Listener function for netbots
       * @param {MessageEvent} event
       */
      netbotsListener(event) {
        if (event.origin !== 'http://www.netbots-robotip.com' && event.origin !== 'https://www.netbots-robotip.com' &&
          event.origin !== 'http://www.api-netbots.com' && event.origin !== 'https://www.api-netbots.com') {
          return;
        }
        if (event.data.market === 'loginName') {
          this.sendPlayerID(event);
          return;
        }

        resetQuickbet();
        if (Array.isArray(event.data.match_object)) {
          const matches = event.data.match_object;
          const market = event.data.odds_object;
          matches.forEach((match, index) => {
            this.addItemToBetslip(match, market[index]);
          });
          return;
        }
        const match = event.data.match_object;
        const market = event.data.odds_object;
        this.addItemToBetslip(match, market);
      },
      /**
       * Send player id to netbots iframe widget 
       * @param {MessageEvent} event
       */
      sendPlayerID(event) {
        event.source.postMessage(APP_SETTINGS.player.id, event.origin);
      },
      getMappedModels(match, market) {
        // General market remapping
        market.id = market.c || market.id;
        market.m = [market.o];
        market.c = undefined;
        // Map for prematch
        if (market.status === 'prematch') {
          match.o = [];
          const m = new PreMatchModel(match);
          const odt = m.mapOdds([market]);
          return {
            match: m,
            market: odt,
          };
        }
        // Map for live match
        if (market.status === 'live') {
          const m = new LiveMatchModel(match, APP_SETTINGS);
          const odt = m.mapOdds({ odds: [market], ht: match.ht, at: match.at, sbv: match.sbv });
          return {
            match: m,
            market: [odt[market.id]],
          };
        }
      },
      addItemToBetslip(match, market) {
        const mappedModels = this.getMappedModels(match, market);
        // If we couldn't map to prematch or live model return
        if (!mappedModels) {
          return;
        }
        const betslip_item = mapMatchToBetslipItem(
          mappedModels.match,
          mappedModels.market[0].outcomes[0],
          mappedModels.market[0],
          false,
          market.status === 'prematch',
          false,
          market.status !== 'prematch');
        const betslipMatchItem = mapMatchToBetslipMatchItem(mappedModels.match);
        if (isOddActive(betslip_item)) {
          return;
        }
        const error = toggleItem(betslip_item, betslipMatchItem);
        showBetslipValidation(error);
      }
    },
  };
</script>